import { normalizeOrgSegment } from './collectionPaths';

/**
 * Collection organization / tenant scoping is temporarily disabled.
 * Mixed org on related collections (e.g. renske_blocks vs renske_pages) breaks item lists.
 * @see https://github.com/tulipandmills/labwick-novo/issues/16
 */
export const ORGANIZATION_SCOPING_DISABLED = true;

export function isOrganizationScopingDisabled(): boolean {
  return ORGANIZATION_SCOPING_DISABLED;
}

/** Route org segment used for Redux keys and API calls. */
export function effectiveRouteOrgNorm(routeOrgNorm: string): string {
  return isOrganizationScopingDisabled() ? '' : routeOrgNorm;
}

/** Query/body org param — omitted while scoping is disabled. */
export function organizationForApi(organization?: string | null): string | undefined {
  if (isOrganizationScopingDisabled()) return undefined;
  const o = typeof organization === 'string' ? organization.trim() : '';
  return o || undefined;
}

export function componentMatchesOrgScope(
  componentOrg: string | null | undefined,
  routeOrgNorm: string
): boolean {
  if (isOrganizationScopingDisabled()) return true;
  return normalizeOrgSegment(componentOrg) === routeOrgNorm;
}

export function pickComponentForSlugWhenScopingDisabled<T extends { organization?: string | null }>(
  slugMatches: T[]
): T | null {
  if (slugMatches.length === 0) return null;
  if (slugMatches.length === 1) return slugMatches[0];
  const personal = slugMatches.find((c) => !normalizeOrgSegment(c.organization));
  return personal ?? slugMatches[0];
}
